import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions/actions'
import requestActions from './actions/requestActions'
import gtmActions from './actions/gtmActions'

import mutations from './mutations/mutations'
import VuexPersistence from 'vuex-persist'

import localUser from '../data/user.js'
import localCartSkipass from '../data/cart_skipass.js'
import localCartSkirental from '../data/cart_skirental.js'
import localCartSkischool from '../data/cart_skischool.js'
import localCartActivities from '../data/cart_activities.js'
import localCartAccommodation from '../data/cart_accommodation.js'

// isLocal == true - will use local data
let isLocal = process.env.VUE_APP_IS_LOCAL == 'yes'
if (isLocal) {
	window.console.warn(
		'User is loaded from local JSON. Set VUE_APP_IS_LOCAL to "no" in the .env.local file to prevent this'
	)
}

const vuexLocal = new VuexPersistence({
	storage: localStorage,
	reducer: state => ({
		weather: state.weather,
		user: state.user,
		//filters: state.filters,
		//filteredAccommodations: state.filteredAccommodations,
		datesAndPeople: state.datesAndPeople,
		//cartTotalPrice: state.cartTotalPrice,
		//checkout: state.checkout,
		cart: state.cart,
		accommodation: state.accommodation,
		campaignCode: state.campaignCode,
		// apiResponseStatus: state.apiResponseStatus,
		token: state.token,
		confirmationId: state.confirmationId
	})
})

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		/*weather: {
			snowHight: null,
			temp: null,
			openLifts: null
		},
		filters: null,
		filteredAccommodations: [],
		datesAndPeople: {
			amountAdults: 0,
			amountChildren: 0,
			amountSeniors: 0,
			amountYouths: 0,
			endDate: '',
			startDate: ''
		},
		cartTotalPrice: null,
		checkout: null,*/

		user: isLocal ? localUser : null,

		cart: {
			customerlid: null,
			allowcancellation: true,
			allowmodification: true,
			resvid: '',
			currency: 'SEK',
			accommodation: isLocal ? localCartAccommodation : [],
			skipass: isLocal ? localCartSkipass : [],
			skischool: isLocal ? localCartSkischool : [],
			skirental: isLocal ? localCartSkirental : [],
			activities: isLocal ? localCartActivities : [],
			deliveryPrice: isLocal ? 199 : -1,
			delivery: false,
			delivertoaccommodation: null,
			delivertoother: null,
			keycardPrice: isLocal ? 65 : null,
			cartCheckoutClicked: false,
			completeCancellation: false,
			everytingIsValid: true,
			fastCheckout: true,
			accordion: {
				showAccommodation: false,
				showSkipass: false,
				showSkischool: false,
				showSkirental: false,
				showActivities: false
			}
		},

		accommodation: {
			apiFilters: {
				bookableDates: [],
				cabinAreas: [],
				facilities: []
			},
			list: [],
			// filteredAcc: [],
			datesAndPeople: {
				amountAdults: 0,
				amountChildren: 0,
				amountSeniors: 0,
				amountYouths: 0,
				endDate: '',
				startDate: ''
			},
			accRandomListOrder: []
		},

		campaignCode: '',
		apiResponseStatus: null,

		token: {
			accessToken: null,
			accessTokenExpiration: null,
			refreshToken: null
		},

		confirmationId: null,

		productList: {
			selectedFilterType: null,
			selectedFilters: [],
			selectedItems: []
		},

		globalModals: {
			showTokenExpired: false,
			showLoginForm: false,
			showAccommodationNotAvailable: false,
			showOutOfDateCartModal: false,
			showCheckoutErrorModal: false
		}
	},
	mutations: mutations,
	actions: { ...actions, ...requestActions, ...gtmActions },
	strict: process.env.NODE_ENV !== 'production',
	plugins: [vuexLocal.plugin]
})
